import { Divider } from "@mui/material";

export const BoZoneDivider = () => (
  <Divider sx={{ borderColor: "rgba(83, 86, 90, 0.06)" }} />
);
